/*
 * 因为在 axios 的 response 拦截器中对响应进行了处理
 * 所以需要对 axios 请求返回的参数类型进行重新定义
 * 采用模块扩充的方式, 对 AxiosInstance 的方法进行覆盖
 * 参考自:
 * */

import { AxiosError, AxiosResponse } from 'axios'

/**
 * 后端code
 */
export enum BizResCode {
  SUCCESS = '00000'
}

// 请求中的page参数
export interface PageReqSchema {
  pageNum: number
  pageSize: number
}

/**
 * 响应中的page
 */
export type PageResSchema = {
  pageNum: number
  pageSize: number
  pages: number
  total: number
}

/**
 * 后端原始响应
 */
export type ResponseSchema<T = any> = {
  code: BizResCode.SUCCESS
  data: T
  message: string
  page: PageResSchema | null
}

/**
 * 经过响应拦截器归一化后的响应
 */
export interface NormalizedResponse<T = any> {
  code: BizResCode.SUCCESS
  data: T
  message: string
  page: PageResSchema | null
  axiosRes: AxiosResponse<T>
}

/**
 * 经过响应拦截器归一化后的错误
 */
interface BaseNormalizedError {
  message: string
  messageHasShown: boolean
}
export interface NormalizedBizError extends BaseNormalizedError {
  code: string
  errorType: 'custom'
  axiosRes: AxiosResponse
}
export interface NormalizedAxiosError extends BaseNormalizedError {
  code: string
  errorType: 'axios'
  axiosError: AxiosError
  httpStatus?: number
}
export interface NormalizedCancelError extends BaseNormalizedError {
  errorType: 'cancel'
}
export type NormalizedError =
  | NormalizedBizError
  | NormalizedAxiosError
  | NormalizedCancelError
